import { Height } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';

const styles = {

  '& .MuiDataGrid-footerContainer': {
    display: 'block !important', 
    opacity: '1 !important',
  },

  '.MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '.MuiDataGrid-columnHeaders': {
    border: 'none'
  },
  '&.MuiDataGrid-root': {
    border: 'none',
    fontFamily: `'Jost',sans-serif`,
  },
  '& .MuiDataGrid-row': {
    cursor: 'pointer'
  },
  '& .MuiDataGrid-cell': {
    paddingTop: '1rem',
    paddingBottom: '1.25rem',
    boxSizing: 'none',
    borderBottom: 'none',
    backgroundPosition: 'top',
    backgroundRepeat: 'repeat-x',
    backgroundSize: '15px 2px',
    backgroundImage: 'linear-gradient(to right, #797676 10%, rgba(255, 255, 255, 0) 0%)',

    '&:focus': {
      outline: 'unset'
    }
  },
  '& .MuiDataGrid-cellContent': {
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
      "& h5": {
        fontSize: "2vh",
      },
    },
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    [`@media (min-width: 2000px)`]: {
      fontSize: "2vh",
    },
  },
  '& .MuiDataGrid-row--lastVisible': {
    "& div": {
      [`@media (min-width: 2000px)`]: {
        fontSize: "2.5vh !important",
        "& h5": {
        fontSize: "2.5vh !important",
        },
        "& img": {
        width:"6vh",
        height: "6vh",
        },
        "& svg": {
          width:"3vw",
          height: "4vh",
        }
      },
    }
  },

  '&.custom-headers .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 400,
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    fontSize: '1rem',
    lineHeight: '20px'
  },

}

const Table = ({ rows, columns, hiddenColumns, applyStyles = false, ...props }) => {
  const [style, setStyle] = useState(styles);

  useEffect(() => {
    if (applyStyles) {
      const updatedStyles = { ...style };

      rows.forEach((row, index) => {
        if (index === 0 || rows[index - 1]?.status === 'Approved' || rows[index - 1]?.status === 'SubmittedForReview' || index > 4 || rows[index + 1]?.status !== "Pending" || rows[index]?.status !== "Pending") {
          updatedStyles[`& .MuiDataGrid-row:nth-child(${index + 1})`] = {
            ...style['& .MuiDataGrid-row'],
            opacity: 1,
            pointerEvents: 'auto',
          };
        } else {
          updatedStyles[`& .MuiDataGrid-row:nth-child(${index + 1})`] = {
            ...style['& .MuiDataGrid-row'],
            opacity: 0.5,
            pointerEvents: 'none',
          };
        }

        if (index === 3) {
          let shouldDisable = false;
          for (let i = 0; i < index; i++) {
            if (rows[i]?.status !== 'Approved') {
              shouldDisable = true;
              break;
            }
          }
          if (shouldDisable) {
            updatedStyles[`& .MuiDataGrid-row:nth-child(${index + 1})`] = {
              ...style['& .MuiDataGrid-row'],
              opacity: 0.5,
              pointerEvents: 'none',
            };
          } else {
            updatedStyles[`& .MuiDataGrid-row:nth-child(${index + 1})`] = {
              ...style['& .MuiDataGrid-row'],
              opacity: 1,
              pointerEvents: 'auto',
            };
          }
        }
      });
      setStyle(updatedStyles);
    }
  }, [rows, applyStyles]);

  return (
    <DataGrid
      sx={style}
      rows={rows}
      columns={columns}
      columnVisibilityModel={hiddenColumns}
      disableSelectionOnClick
      pageSize={5}
      rowsPerPageOptions={[5]}
      {...props}
    />
  );
};

export default Table;